/**
 * Inventory Store
 *
 * @since 2018-08-23
 * @author Nanhyoung.Ro <dev014>
 */
import { parseJSON } from '~/utils/common'

export const state = () => ({
  apiPreFix: '/api/lr',
  profileApi: '/report/profiles',
  commandApi: '/command/report-profiles',
  groupsApi: '/report/groups',
  // ===  onSearch ===
  search: {},
  profileInfos: [],
  groupDeviceList: []
})

export const mutations = {
  initStore (state) {
    state.search = {}
    state.profileInfos = []
    state.groupDeviceList = []
    state.postData = null
    state.profileErrorMessage = ''
  },
  clearGroupDeviceList (state) {
    state.groupDeviceList = []
  },
  setGroupDeviceList (state, payload) {
    state.groupDeviceList = payload
  },
  clearProfileInfos (state) {
    state.profileInfos = []
  },
  setProfileInfos (state, payload) {
    state.profileInfos = _.map(payload, row => {
      row.cate = parseJSON(row.report_grp_page_set)
      return row
    })
  }
}

export const actions = {
  // 리포트 프로파일 조회
  async getSearchResult ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}`
      res = await this.$axios.$get(apiUrl, {loading: false})

      if (res.code === 'ok') {
        commit('setProfileInfos', res.result)
      } else {
        commit('clearProfileInfos')
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      commit('clearProfileInfos')
    }
    return res
  },
  // 리포트 프로파일 설정 리스트 조회
  async getPopupResult ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}/contents`
      res = await this.$axios.$get(apiUrl, {loading: false})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 로그/리포트 > 리포트 > 리포트 그룹 관리 > 리포트 그룹 빈 템플릿 추가
  async postReportGroups ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}`
      res = await this.$axios.$post(apiUrl, void 0, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 로그/리포트 > 리포트 > 리포트 그룹 관리 > 리포트 그룹 빈 템플릿 수정
  async putReportGroups ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }

    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}/${payload.report_grp_id}`
      res = await this.$axios.$put(apiUrl, payload.params, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 로그/리포트 > 리포트 > 리포트 그룹관리 > 리포트 그룹 삭제
  async deleteReportGroups ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}?report_grp_id_list=${JSON.stringify(payload.report_grp_id_list)}`
      res = await this.$axios.$delete(apiUrl, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // GET /api/lr/report/groups/device/{report_grp_id}
  async getGroupsDeviceId ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}/device/${payload.report_grp_id}`
      res = await this.$axios.$get(apiUrl, { loading: false })

      if (res.code === 'ok') {
        commit('setGroupDeviceList', res.result)
      } else {
        commit('clearGroupDeviceList')
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
      commit('clearGroupDeviceList')
    }
    return res
  },
  async postGroupsDeviceId ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}/device/${payload.report_grp_id}`
      res = await this.$axios.$post(apiUrl, payload.params, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },

  async applySettings ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}/apply`
      res = await this.$axios.$put(apiUrl, null, {applyMsg: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },

  async cancelSettings ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const apiUrl = `${state.apiPreFix}${state.groupsApi}/cancel`
      res = await this.$axios.$put(apiUrl, null, {cancelMsg: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}
export const getters = {}
export const strict = false
